/* 419DRIVER — motion layer
   1. inertial (lerped) wheel scrolling   2. scroll reveals
   3. cross-document fade transitions     4. custom cart drawer
   Written for 419DRIVER; no third-party libraries. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* =========================================================
     1. Inertial scroll
     Native scroll position is preserved (we call window.scrollTo),
     so position:sticky / position:fixed keep working — a transform
     wrapper would break both.
     ========================================================= */
  function initSmoothScroll() {
    if (reduce) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return; // touch has native momentum

    var target = window.scrollY;
    var current = window.scrollY;
    var running = false;
    var locked = false;
    var EASE = 0.11;

    function maxScroll() {
      return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    }

    function frame() {
      var diff = target - current;
      if (Math.abs(diff) < 0.4) {
        current = target;
        window.scrollTo(0, current);
        running = false;
        return;
      }
      current += diff * EASE;
      window.scrollTo(0, current);
      requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      running = true;
      requestAnimationFrame(frame);
    }

    window.addEventListener('wheel', function (e) {
      if (locked) return;
      if (e.ctrlKey) return;                                  // pinch-zoom
      if (e.target.closest('[data-drvr-native-scroll]')) return; // inner scrollers
      e.preventDefault();
      target = Math.min(Math.max(target + e.deltaY, 0), maxScroll());
      start();
    }, { passive: false });

    // keep in sync when anything else moves the page
    window.addEventListener('scroll', function () {
      if (!running) { target = current = window.scrollY; }
    }, { passive: true });
    window.addEventListener('resize', function () { target = current = window.scrollY; });

    document.addEventListener('drvr:scrolllock', function (e) {
      locked = !!e.detail;
      target = current = window.scrollY;
    });
  }

  /* =========================================================
     2. Scroll reveals
     ========================================================= */
  function initReveals() {
    var els = document.querySelectorAll('.drvr-reveal:not([data-revealed])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.setAttribute('data-revealed', '1'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.setAttribute('data-revealed', '1');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* =========================================================
     3. Page transitions
     Chrome gets a true cross-document view transition from the
     @view-transition rule in CSS. Everything else gets this
     fade-out / fade-in veil so navigation never hard-flashes.
     ========================================================= */
  function initPageFade() {
    if (reduce) return;
    if (CSS && CSS.supports && CSS.supports('view-transition-name: none') &&
        'startViewTransition' in document) return; // native handles it

    document.documentElement.setAttribute('data-drvr-fade', 'in');
    window.addEventListener('pageshow', function () {
      document.documentElement.setAttribute('data-drvr-fade', 'in');
    });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      var url;
      try { url = new URL(a.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search) return;

      e.preventDefault();
      document.documentElement.setAttribute('data-drvr-fade', 'out');
      setTimeout(function () { window.location.href = a.href; }, 190);
    });
  }

  /* =========================================================
     4. Cart drawer
     ========================================================= */
  var drawer, listEl, subtotalEl, countEls;

  function cartMarkup() {
    var el = document.createElement('div');
    el.className = 'drvr-cart';
    el.setAttribute('data-drvr-cart', '');
    el.setAttribute('data-open', 'false');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Cart');
    el.innerHTML =
      '<div class="drvr-cart__veil" data-drvr-cart-close></div>' +
      '<aside class="drvr-cart__panel">' +
        '<header class="drvr-cart__head">' +
          '<span>Your cart</span>' +
          '<button type="button" class="drvr-iconbtn" data-drvr-cart-close aria-label="Close cart">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 5l14 14M19 5 5 19"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="drvr-cart__body" data-drvr-native-scroll data-drvr-cart-list></div>' +
        '<footer class="drvr-cart__foot">' +
          '<div class="drvr-cart__sub"><span>Subtotal</span><span data-drvr-cart-subtotal>$0.00</span></div>' +
          '<p class="drvr-cart__note">Shipping and taxes calculated at checkout.</p>' +
          '<a class="drvr-btn drvr-btn--hi drvr-btn--wide" href="/checkout"><span>Checkout</span><span data-drvr-cart-subtotal2></span></a>' +
        '</footer>' +
      '</aside>';
    return el;
  }

  function setCartOpen(state) {
    drawer.setAttribute('data-open', state ? 'true' : 'false');
    document.documentElement.style.overflow = state ? 'hidden' : '';
    document.dispatchEvent(new CustomEvent('drvr:scrolllock', { detail: state }));
    if (state) render();
  }

  function lineMarkup(item, i) {
    // Use the URL Shopify gives us verbatim — rewriting it (size suffix or an
    // appended width param) is what broke the thumbnail. Fall back to the grey
    // placeholder if it ever fails to load.
    var img = item.image
      ? '<img src="' + item.image + '" alt="" width="80" height="100" loading="lazy" ' +
        'onerror="this.replaceWith(Object.assign(document.createElement(\'span\'),{className:\'drvr-cart__ph\'}))">'
      : '<span class="drvr-cart__ph"></span>';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="drvr-cart__variant">' + item.variant_title + '</span>' : '';
    var compare = item.original_line_price > item.final_line_price
      ? '<s>' + money(item.original_line_price) + '</s>' : '';
    return '' +
      '<div class="drvr-cart__line" data-key="' + item.key + '">' +
        '<a class="drvr-cart__thumb" href="' + item.url + '">' + img + '</a>' +
        '<div class="drvr-cart__info">' +
          '<a class="drvr-cart__name" href="' + item.url + '">' + item.product_title + '</a>' +
          variant +
          '<div class="drvr-cart__price"><span class="is-sale">' + money(item.final_line_price) + '</span>' + compare + '</div>' +
          '<div class="drvr-cart__qty">' +
            '<button type="button" data-drvr-qty="' + (item.quantity - 1) + '" data-key="' + item.key + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-drvr-qty="' + (item.quantity + 1) + '" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
            '<button type="button" class="drvr-cart__remove" data-drvr-qty="0" data-key="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function render() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          listEl.innerHTML = '<div class="drvr-cart__empty"><p>Your cart is empty.</p>' +
            '<a class="drvr-btn" href="/collections/all">Start shopping</a></div>';
        } else {
          listEl.innerHTML = cart.items.map(lineMarkup).join('');
        }
        var total = money(cart.total_price);
        drawer.querySelectorAll('[data-drvr-cart-subtotal], [data-drvr-cart-subtotal2]')
          .forEach(function (el) { el.textContent = total; });
        drawer.querySelector('.drvr-cart__foot').hidden = !cart.items.length;
        document.querySelectorAll('[data-drvr-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () {});
  }

  function change(key, qty) {
    drawer.setAttribute('data-busy', 'true');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { return render(); })
      .finally(function () { drawer.removeAttribute('data-busy'); });
  }

  function initCart() {
    if (document.querySelector('[data-drvr-cart]')) return;
    drawer = cartMarkup();
    document.body.appendChild(drawer);
    listEl = drawer.querySelector('[data-drvr-cart-list]');

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drvr-cart-close]')) { setCartOpen(false); return; }
      var q = e.target.closest('[data-drvr-qty]');
      if (q) change(q.getAttribute('data-key'), Number(q.getAttribute('data-drvr-qty')));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') setCartOpen(false);
    });

    // cart icon opens the drawer instead of navigating
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
      if (!link) return;
      e.preventDefault();
      setCartOpen(true);
    });

    // quick-add + PDP add open the drawer
    document.addEventListener('drvr:added', function () { setCartOpen(true); });
  }


  /* =========================================================
     5. Vertical cut reveal  (technique: Fancy "vertical-cut-reveal")
     Each word sits in an overflow-hidden box and slides up from
     below the mask, staggered. Ported to vanilla CSS/JS.
     ========================================================= */
  function splitCut(el) {
    if (el.dataset.cutReady === '1') return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;
    el.dataset.cutReady = '1';
    var words = text.split(' ');
    el.textContent = '';
    words.forEach(function (w, i) {
      var box = document.createElement('span');
      box.className = 'drvr-cut__w';
      var inner = document.createElement('span');
      inner.className = 'drvr-cut__i';
      inner.textContent = w;
      inner.style.animationDelay = (i * 0.055) + 's';
      box.appendChild(inner);
      el.appendChild(box);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  function initCutReveal() {
    var els = document.querySelectorAll('[data-drvr-cut]:not([data-cut-ready])');
    if (!els.length) return;
    els.forEach(function (el) {
      splitCut(el);
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.1) {
        el.setAttribute('data-cut-ready', '1');       // on screen: play now
      } else if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          el.setAttribute('data-cut-ready', '1');
          io.disconnect();
        }, { threshold: 0.2 });
        io.observe(el);
      } else {
        el.setAttribute('data-cut-ready', '1');
      }
    });
  }

  /* =========================================================
     6. Focus grid  (technique: Aceternity "focus-cards")
     Hovering one card softens every sibling.
     ========================================================= */
  function initFocusGrid() {
    document.querySelectorAll('.drvr-grid').forEach(function (grid) {
      if (grid.dataset.focusBound === '1') return;
      grid.dataset.focusBound = '1';
      grid.addEventListener('mouseover', function (e) {
        var card = e.target.closest('.drvr-card');
        if (card) grid.setAttribute('data-focus', 'true');
      });
      grid.addEventListener('mouseleave', function () {
        grid.removeAttribute('data-focus');
      });
    });
  }

  /* =========================================================
     7. Scroll progress bar
     ========================================================= */
  function initProgress() {
    if (document.querySelector('.drvr-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'drvr-progress';
    bar.innerHTML = '<span></span>';
    document.body.appendChild(bar);
    var fill = bar.firstChild;
    function upd() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      fill.style.width = Math.min(100, Math.max(0, pct)) + '%';
    }
    upd();
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
  }

  function boot() {
    initSmoothScroll();
    initReveals();
    initPageFade();
    initCart();
    initCutReveal();
    initFocusGrid();
    initProgress();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { initReveals(); initCutReveal(); initFocusGrid(); });
})();
